import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTwitter, FiStar } = FiIcons;

const quotes = [
  {
    name: "Marcus Chen",
    role: "Fullstack Engineer",
    text: "DidThis changed my hiring game. I just sent my profile link and the CTO was blown away by the session logs.",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=150"
  },
  {
    name: "Elena Rodriguez",
    role: "Founding Designer",
    text: "The zero-friction aspect is real. I forget I'm even 'building in public' until I see my beautiful timeline at the end of the day.",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=150"
  },
  {
    name: "Jordan Smith",
    role: "Solopreneur",
    text: "I used to spend 2 hours a week drafting 'update' posts. Now AI does it in 2 seconds. This is a superpower.",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=150"
  }
];

export default function Testimonials() {
  return (
    <section className="py-24 bg-slate-900/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
          <div>
            <h2 className="text-4xl font-black text-white italic uppercase tracking-tighter mb-4">Loved by builders</h2>
            <p className="text-slate-400 font-medium">Join 5,000+ creators shipping with DidThis.</p>
          </div>
          <div className="flex -space-x-3">
            {[1, 2, 3, 4, 5].map(i => (
              <img key={i} src={`https://i.pravatar.cc/100?img=${i+10}`} className="w-12 h-12 rounded-full border-4 border-slate-950" alt="User" />
            ))}
            <div className="w-12 h-12 rounded-full bg-primary border-4 border-slate-950 flex items-center justify-center text-[10px] font-black text-white">+2k</div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {quotes.map((quote, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="glass-card p-8 flex flex-col justify-between"
            >
              <div className="mb-8">
                <div className="flex text-accent mb-4">
                  {[1, 2, 3, 4, 5].map(i => <SafeIcon key={i} icon={FiStar} className="w-3 h-3 fill-current" />)}
                </div>
                <p className="text-slate-300 font-medium leading-relaxed italic">"{quote.text}"</p>
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <img src={quote.avatar} className="w-10 h-10 rounded-xl" alt={quote.name} />
                  <div>
                    <h4 className="text-sm font-black text-white uppercase tracking-tight">{quote.name}</h4>
                    <p className="text-[10px] text-slate-500 font-bold uppercase tracking-widest">{quote.role}</p>
                  </div>
                </div>
                <SafeIcon icon={FiTwitter} className="w-4 h-4 text-slate-600" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}